const uk_UA_in_risks_page = {
  address: 'Адреса контракту ',
  type: 'Тип',
};
const uk_UA = {
  deposit: 'депозит',
  Deposit: 'Депозит',
  withdraw: 'зняття',
  Withdraw: 'Зняття',
  swap: 'своп',
  Swap: 'Своп',
  pool: 'Пул',
  Pool: 'Пул',
  pools: 'Пули',
  Pools: 'Пули',
  view_pools: 'Огляд пулів',
  view_pool: 'Огляд пулу',
  add_token: 'додати токен',
  create_new_pool: 'створити новий пул',
  Create_New_Pool: ' Створити новий Пул',
  your_liquidity: 'Ваша ліквідність',
  Your_Liquidity: 'Ваша Ліквідність',
  farms: 'Фарм',
  Farms: 'Фарм',
  docs: 'Документи',
  account: 'Акаунт',
  Discord: 'Discord',
  Telegram: 'Telegram',
  Twitter: 'Twitter',
  connect_to_near: 'Підключитись до NEAR',
  slippage: 'Допуск прослизання',
  minimum_received: 'Мінімум отриманий',
  swap_rate: 'Ставка свопу',
  pool_fee: 'Комісія пулу',
  balance: 'Баланс',
  from: 'Від',
  to: 'До',
  submit: 'Прийняти',
  view_account: 'Огляд акаунта',
  liquidity: 'Ліквідність',
  tokens: 'Токени',
  fee: 'комісія',
  fees: 'комісії',
  details: 'Деталі',
  detail: 'Деталі',
  minimum_tokens_out: 'Мін. кількість отриманих',
  pair: 'Пара',
  tvl: 'TVL',
  add_liquidity: 'Додати ліквідність',
  remove_liquidity: 'Забрати ліквідність',
  total_liquidity: 'Загальна ліквідність',
  my_shares: 'Моя частка',
  token: 'Токен',
  enter_token_address: 'Введіть адресу токена',
  remove: 'Видалити',
  select: 'Вибрати',
  select_token: 'Вибрати токен',
  total_fee: '% загальної комісії ',
  start_at: 'Початок в ',
  end_at: 'Закінчення о ',
  ended: 'Закінчився',
  pending: 'ОЧІКУЄ',
  rewards_per_week: 'Винагороди за тиждень',
  apr: 'APR',
  total_staked: 'Загальна кількість в стейкінгу',
  unclaimed_rewards: 'Неотримані винагороди',
  claim: 'Отримати',
  claim_all: 'Отримати Все',
  stake: 'Стейкінг',
  unstake: 'Анстейкінг',
  your_shares: 'Ваші частки',
  cancel: 'Скасувати',
  days: 'днів',
  slippageCopyForMobile:
    'Прослизання означає різницю між тим, що ви очікуєте отримати, і тим, що ви насправді отримаєте, при виконанні інших ордерів першими',
  slippageCopy:
    'Прослизання означає різницю між тим, що ви очікуєте отримати, і тим, що ви насправді отримаєте, при виконанні інших ордерів першими',
  swapCopy:
    'Своп обмінює перший вибраний токен на другий  <br> вибраний токен. Будуть використані пули з найвищою доступною ліквідністю та найнижчою комісією обміну',
  addTokenCopy: 'Додайте будь-який NEP-141 токен',
  farmRewardsCopy:
    'Орієнтовна вартість на основі цін, а не фактичного виконання',
  you_do_not_have_enough: 'У вас недостатньо',
  is_not_exist: 'не існує',
  must_input_a_value_greater_than_zero: 'Необхідно ввести значення більше 0',
  no_pool_available_to_make_a_swap_from: 'Відповідні пули для обміну відсутні',
  for_the_amount: 'на суму',
  no_pool_eng_for_chinese: ' ',
  is_not_a_valid_swap_amount: 'недійсна кількість свопу',
  not_nep_address:
    'Введена адреса не є адресою NEP-141, перевірте та введіть її ще раз. Якщо це інший контракт основної мережі, перейдіть до Rainbow Bridge для обробки через міст',
  not_correct_address:
    'Введена адреса неправильна, будь ласка перевірте її ще раз',
  pool_id: 'ID пулу',
  more_pools: 'Більше пулів',
  my_watchlist: 'Список спостережень',
  h24_volume: 'Обсяг за добу',
  volume: 'Volume',
  hide_low_tvl_pools: 'Приховати низький TVL',
  hide_low_tvl_pools_mobile: 'Приховати низький TVL',
  my_watchlist_copy: 'Тут з’являться обрані пули',
  language: 'Мова',
  deposit_to_add_liquidity: 'Здійсніть депозит, щоб додати ліквідність',
  slip_warn: 'Будьте обережні, перевірте мінімум, який ви можете отримати',
  slip_invalid: 'Допус прослизання неправильний',
  reward_tokens: 'Токени винагород',
  detail_tip: 'Деталі',
  no_data: 'Дані відсутні',
  attention: 'Увага',
  live: 'LIVE',
  ended_search: 'Завершено',
  my_farms: 'Ваш фарм',
  sort_by: 'Сортувати за',
  your_farms: 'Ваш фарм',
  new: 'Нові',
  unstake_tip_t: 'У вас є неотримані винагороди...',
  unstake_tip_m:
    'Анстейкінг видаляє активи стейкінгу з усіх активних та очікуючих пулів фарму по одній парі.',
  unstake_tip_b: 'Ви дійсно бажаєте здійснити анстейкінг?',
  value_rewards: 'Отримані винагороди',
  stake_unstake_tip:
    'Стейкінг або анстейкінг автоматично отримає ваші винагороди.',
  over_tip:
    'Через обмеження комісії gas, одночасно можна вибрати не більше 4 позицій.',
  no_token_tip: 'Винагорода у токенах відсутня',
  getToken_tip:
    'Ви можете отримати свої винагороди або здійснити стейкінг своїх токенів LP прямо зараз!',
  in_farm: 'У фармі',
  price_impact: 'Вплив ціни',
  roi_calculator: 'ROI калькулятор',
  lp_staked: 'LP стейкінгу',
  usd: 'USD',
  lp_token: 'LP токен',
  stake_for: 'Тривалість',
  day_1: '1 дн.',
  day_2: '7 дн.',
  day_3: '30 дн.',
  day_4: '90 дн.',
  cur_apr: 'ROI',
  reward_token: 'Токени винагород',
  get_lp_token: 'Отримати LP частки',
  calculate_roi: 'ROI калькулятор',
  rewards_claimed: 'Винагороди отримано',
  value_rewards_token: 'Вартість винагород',
  all: 'Всі',
  all_5: '4 токенів за раз',
  more_than: 'Будь ласка, введіть число, яке більше або дорівнює 0,01',
  less_than: 'Будь ласка, введіть число менше 20',
  no_valid: 'Будь ласка, введіть дійсний номер',
  lp_fee: 'LP комісія',
  referral_fee: 'Реферальна комісія',
  protocol_fee_referral_fee: 'Комісія за протокол і реферальна плата',
  total_fee_create: 'Загальна комісія',
  ref: 'REF',
  are_you_sure: 'Ви впевнені',
  price_impact_is_about: 'Вплив на ціну становить приблизно',
  yes_swap: 'Так, здійснити своп',
  input_greater_than_available_shares: 'Введіть більше, ніж доступні частки',
  auto_router: 'Автомобільний роутер',
  optimal_path_found_by_our_solution:
    'Оптимальний шлях, знайдений нашим рішенням',
  make_sure_you_understand_what_you_do:
    'Переконайтеся, що ви розумієте, що ви робите',
  filter_by: 'Відфільтрувати за',
  allOption: 'Всі',
  stablecoin: 'Стейблкоїн',
  near_ecosystem: 'Екосистема Near',
  bridged_tokens: 'Токени мосту',
  gaming: 'Ігри',
  nft: 'NFT',
  bridge: 'Міст до/з',
  no_result: 'На жаль, нам не вдалося знайти відповідний пул фарму',
  multiple: 'Декілька',
  default: 'За замовчуванням',
  create: 'створювати',
  select_a: 'Select a',
  wallet: 'wallet',
  to_use_ref_finance: 'to use {appName}',
  not_supported: 'not supported',
  installed: 'installed',
  installe_now: 'install now',
  extension: 'extension',
  first_time_using_ref: 'First time using {appName}',
  learn_more: 'Вивчайте більше',
  install_sender_now: 'Install Sender Now',
  connect_to_dapps_with_one_click: 'Connect to dApps with one click',
  install: 'install',
  Connecting: 'Connecting',
  check_sender_wallet_extension: 'Please check Sender wallet extension',
  having_trouble: 'Having trouble?',
  go_back: 'Go back',
  web: 'web',
  Type: 'Тип',
  click_to_view: 'Клацніть, щоб переглянути',
  transaction_failed: 'Не вдалося виконати операцію',
  wallet_vi: ' ',
  value: 'значення',
  usd_value: 'USD Value',
  initialize_account_tip: 'Будь ласка, ініціалізуйте свій обліковий запис.',
  support_ledger_tip:
    'За своєю конструкцією Ledger не дозволяє обробляти великі транзакції (торгівлю через кілька пулів одночасно - Auto Router) через обмеження пам\'яті. У разі активації опції "Support Ledger" транзакції будуть обмежені до їхнайпростішої форми (оптимальні ціни необхідно обирати самостійно, Auto Router в цьому випадку не працює), і можуть бути підписані.',
  start: 'Початок',
  max: 'Max',
  ref_account_balance_tip:
    'Схоже сталася помилка, при додаванні/вилученні ліквідності в пулі',
  ref_account_tip_2: 'У вашому обліковому записі REF є токен(и)',
  ref_account_tip_top: 'ймовірно токен(и) знаходяться на вашому рахунку REF',
  click_here: 'Натисніть тут',
  to_recover_them: 'щоб їх відновити',
  ref_account_tip_3:
    'Щоб вивести токени з вашого облікового запису REF на свій гаманець NEAR, виберіть і витягніть',
  aurora_account_tip_4:
    'Щоб вивести токени з картографічного облікового запису на свій гаманець NEAR, виберіть і вийдіть',
  buy: 'Купити',
  sell: 'Продати',
  rate: 'Рейтинг',
  name: "Ім'я",
  diff: 'Дифs',
  best: 'Найкращий',
  awesomeNear_verified_token: 'Токен перевірений AwesomeNear Verified Token',
  pool_fee_apr: 'Pool fee APY',
  ref_account_balance_tip_mobile: 'У вашому обліковому записі REF є токени.',
  click: 'Натисніть',
  to_recover: 'для відновлення.',
  rewards_week: 'Rewards/week',
  rewards: 'Rewards',
  claimed_Rewards: 'Отримані нагороди',
  POOL: 'Пули',
  lp_Token: 'LP Tokens',
  booster: 'Booster',
  append: 'Append',
  farm: 'Farm',
  status: 'Status',
  Rewards: 'Rewards',
  free: 'Free',
  lp_tokens: 'LP токени',
  connect_to_wallet: 'Підключити гаманець',
  slash_policy_content:
    'Each seed has its own slash rate. And it will decreases linearly over time until be 0 at the unlock time of this CD Account.',
  not_expired: 'Not expired',
  accept_pay_slash_tip: 'I accept to pay slash',
  i_will_pay: 'I will pay',
  lp_token_slash: 'LP token exit fee.',
  expired: 'Expired',
  all_4_v2: '4 токенів/час',
  more_than_seed: 'Input must be greater than or equal to ',
  how_to_earn_more: 'Як поєднати винагороду?',
  lock_your_lp_tokens_with_booster: 'Lock your LP tokens for boosted rewards',
  unstaked_anytime_no_booster: 'Unstaked anytime, no booster',
  locking_stake: 'Lock-up staking',
  change_to_lock: 'Change to Lock-up staking',
  estimated_rewards: 'Estimated rewards',
  final_booster: 'Final Booster',
  existing_amount: 'Existing amount',
  append_amount: 'Append amount',
  will_be_able_to_unstaked_after: 'will be able to unstaked after',
  you_have: 'Ви маєте',
  reward_apr: 'Rewards APR',
  stake_min_deposit: 'Введене значення має дорівнювати або бути більше ',
  unlock: 'Unlock',
  exit_fee: 'Exit fee',
  end_locking_period: 'End of locking period',
  add_lp_tokens_tip:
    'LP токени потрібно стейкати в відповідній фермі. Спочатку добавте ліквідність в пул щоб отримати LP токени.',
  slash_tip: 'Exit fee = Exit fee rate * End of locking period * Unlock amount',
  nonBoosted: 'Без стимулів',
  exit_fee_tip: 'Estimated amount you would pay to break your lock-up period',
  forbiddenTip: 'This farm does not support this duration option',
  unstakeTip: 'При стейкінгу та анстейкінгу винагороди автоматично збираються ',
  endedFarmsUnstakeTip:
    'Анстейкінг забере ваш стейк з усіх активних та очікуючих ферм тої самої пари ',
  comimg: 'протягом',
  appendTip: 'Не може бути раніше, ніж поточний час блокування',
  week: 'тиждень ',
  yours: 'Ваш',
  boost: 'підсилення',
  near: 'NEAR',
  eth: 'ETH',
  others: 'інші',
  stakeLove: 'стейкінг LOVE',
  unstakeLove: 'анстейкінг LOVE',
  get_love: 'отримати LOVE',
  swap_successful: 'Обмін успішно. ',
  trading_successfull: 'Торгівля успішна. ',
  available_to_stake: 'є можливість стейкінгу',
  your_assets: 'Ваші активи',
  connect_wallet: 'Підключіть гаманець',
  disconnect: 'Відключити',
  change: 'Змінити',
  connect: 'Підключити',
  veTip: 'Токени veLP не підлягають передачі, veLPT дають вам право голосу ',
  loveTip:
    'LOVE розшифровується як Liquidity Of veToken. LOVE, як і будь-який токен NEP-141, можна передавати, обмінювати, закидати в пули, стейкати та фармити. LOVE представляє основну ліквідність ваших veTokens',
  keep_ve: 'тримати',
  months: 'міяці',
  month: 'місяць',
  lock_lp_tokens: 'Блокування токенів LP',
  get_lptoken: 'Отримання токенів LP',
  duration: 'Тривалість',
  ve_lock_tip: 'Не може бути раніше поточної дати розблокування',
  get: 'отримати',
  you_have_no_lp_share: 'У вас немає LP токенів',
  lock: 'Блок',
  locked: 'Заблоковані',
  available: 'в наявності',
  in: 'в',
  filter: 'фільтер',
  options: 'опції',
  ratio: 'Ratio',
  back: 'назад',
  confirm: 'Підтвердити',
  total: 'Загальна кількість',
  type: 'Тип',
  connect_to_near_wallet: 'Підключитись до NEAR Wallet',
  v1Legacy: 'Спадок',
  v2New: 'Classic-Новий',
  v2_new_farms: 'Classic Нові Ферми',
  migrate_now: 'міграцію зараз ! ',
  v2_boost_tip:
    'Ферми Classic підтримуватимуть посилені ферми. На фермах Legacy закінчаться нагороди <span class="font-bold">1st. August, 2022.</span>',
  v2_boost_no_tip:
    'На фермах Legacy закінчаться нагороди <span class="font-bold">1st. August, 2022.</span>',
  love: 'LOVE',
  Available_to_stake: 'Доступно для Стейкінгу',
  you_staked: 'Застейкано',
  has_rewards_tip_in_v2:
    'Legacy rewards to be withdraw in <a rel="noopener noreferrer nofollow" href="/farms" class="text-sm text-greenColor cursor-pointer underline ml-1 hover:text-senderHot"> Legacy Farms</a>.',
  how_to_get: 'Як отримати?',
  get_booster: 'отримати Booster',
  ended_farms: 'Закінчені ферми',
  boosted_farms: 'Boosted farms',
  your_farm: 'Ваші ферми',
  your_boosted_farms: 'Your boosted farms',
  search_farms_by_token: 'Шукати ферму за токеном',
  search_farms: 'пошук ферм',
  more_lock_ve_popup2: 'більше',
  left: 'Залишки',
  create_pool: 'Створити пул',
  search_by_token: 'Пошук за токеном',
  your_power: 'Ваша сила',
  farm_has_boost_tip:
    'Ваша сила = Ваші LP токени в стейкінгу * бустер (стейкаючи токени Love)',
  farm_no_boost_tip: 'Ваша сила = Your staked LP Tokens',
  more_than_a_simple_pool: 'Більше ніж просто пул',
  ended_Farms: 'закінчені ферми',
  vote_capital: 'Голосування',
  boostFarmTip: 'Отримайте додаткові стимули за стейкінг LOVE',
  boosted: 'Зі стимулами',
  love_staked: 'Застейкані LOVE',
  your_apr: 'Ваш APR',
  range_apr: 'Діапазон чи стандартний APR',
  no_pair_found: 'Пари не знайдено',
  found_stable_pool_in_sauce: 'Знайдено стабільний пул у SAUCE',
  lp_tokens_locking: ' LP токени ',
  you_currently_have: 'Ви зараз маєте ',
  scheduled_to_be_unlocked: 'заплановано для розблокування',
  locking_more_lp_tokens: 'Блокування більше токенів LP ',
  will_mean_these: 'буде означати ці ',
  lp_tokens_will_not_be_unlocked_until: ' Токени LP не буде розблоковано до',
  "I_understand_that_I_won't_be_able_to_remove_my":
    'Я розумію, що не зможу видалити свій ',
  until: 'поки',
  add: 'додати',
  finish: 'Закінчити',
  add_custom_network: 'Додати спеціальну мережу',
  network_name: 'Назва мережі',
  rpc_name_taken_tip: 'Назва мережі вже зайнята',
  network_invalid: 'Мережа була недійсною',
  fobidden_testnet_rpc_tip:
    'Мережа сервера RPC (testnet) відрізняється від цієї мережі (mainnet)',
  no_support_testnet_rpc_tip: 'Testnet не підтримує додавання власного RPC',
  stable: 'Stable',
  limit: 'Ліміт',
  your_active_orders_will_appear_here:
    'Ваші активні ордери відображатимуться тут',
  your_history_orders_will_appear_here:
    'Історія ваших ордерів відображатиметься тут',
  farm_only: 'Тільки ферма',
  please_confirm_this_transaction_on_ledger:
    'Підтвердьте цю транзакцію в Ledger',
  limit_order: 'Лімітний ордер',
  farm_stop_tip: 'Ця ферма зупинена.',
  pool_stop_tip: 'Цей пул зупинений.',
  volume_24h: 'Обсяг (24 години)',
  add_to_watchlist: 'Додати до спостережень',
  remove_from_watchlist: 'Прибрати зі спостережень',
  create_order: 'Створити ордер',
  filled: 'Заповнений',
  canceled: 'Відмінено',
  partially_filled: 'Частково заповнений',
  pool_composition: 'Склад пулу',
  amount: 'Кількість',
  h24_volume_bracket: 'Обсяг (24 години)',
  fee_24h: 'Комісія (24 години)',
  orders: 'замовлення',
  your_orders: 'Ваші замовлення',
  active: 'Активний',
  history: 'Історія',
  you_sell: 'Ваші продажі',
  you_buy: 'Ваші покупки',
  fee_tiers: 'Рівні комісій',
  created: 'Створено',
  executed: 'Виконаний',
  actions: 'Дії',
  claimed_upper: 'Отримано',
  open_my_order: 'Відкрити',
  initial_order: 'Початковий ордер',
  this_order_has_been_partially_filled: 'Цей ордер заповнений частково',
  filled_via_swap: 'Заповнено за рахунок обміну',
  state: 'Стан',
  partially: 'Частково',
  near_validation_error: 'Must have 0.5N or more left in wallet for gas fee.',
  near_min_validation_error:
    'Must have 0.2N or more left in wallet for gas fee.',
  no_positons_in_this_pool_yet: 'No positons in this pool yet',
  no_claimed_rewards_yet: 'No claimed rewards yet',
  out_of: 'out of',
  fee_Tiers: 'Рівні Комісій',
  no_pool: 'Пул відсутній',
  input_amount: 'Зазначте кількість',
  update_range: 'Оновити діапазон',
  not_enough_balance: 'Не достатній баланс',
  set_price_range: 'Встановити ціновий діапазон',
  current_price: 'Ціна зараз',
  invalid_range_tip:
    'Задано не вірний діапазон. Мінімальна ціна має бути нижчою за максимальну.',
  maket_price_outside_single_only_tip:
    'Ринкова ціна знаходиться за межами вашого цінового діапазону. Внесіть тільки один актив.',
  min_price: 'Мінімальна ціна',
  max_price: 'Максимальна ціна',
  min: 'Мін',
  out_of_range: 'Поза межами',
  in_range: 'В межах',
  unclaimed_fees: 'Неотримані комісії',
  your_position_will_be: 'Ваша позиція буде',
  at_this_price: 'за цією ціною',
  price_range: 'Ціновий діапазон',
  positions: 'Позиції',
  position: 'Position',
  range: 'Діапазон',
  login_risk_tip:
    'By checking this box and moving forward, you confirm that you fully understand the risks of using {appName}.',
  stable_pool: 'Stable Pool',
  market_rate: 'Market Rate',
  no_token_found: 'No token found',
  search_name_or_address: 'Search name or paste address...',
  token_address_invalid: 'The token address was invalid',
  price_impact_warning: 'Price Impact Warning',
  confirm_order: 'Confirm Order',
  you_Sell: 'You Sell',
  to_Buy: 'to Buy',
  at_Price: 'at Price',
  insufficient_balance: 'Insufficient Balance',
  limitTip: 'Your price is automatically set to the closest price slot',
  v2_pools: 'DCL Pools',
  v2_your_pool_introduction: 'Your discretized concentrated liquidity',
  v1_your_pool_introduction: 'Your liquidity in classic pools',
  estimate_value: 'Estimate Value',
  price: 'Price',
  '@price': '@Price',
  trades: 'Trades',
  time: 'Time',
  balances: 'Balances',
  asset: 'Asset',
  action: 'Action',
  market: 'Market',
  Maker: 'Maker',
  chart: 'Chart',
  refresh_data_to_continue: 'Please refresh the data to continue',
  refresh: 'Refresh',
  both: 'Both',
  All: 'All',
  Filled: 'Filled',
  assets: 'Assets',
  cancel_order: 'Cancel Order',
  instrument: 'Instrument',
  dex: 'Dex',
  limit_order_created: 'Limit Order Created',
  limit_order_filled: 'Limit Order Filled',
  classic_pools: 'Classic Pools',
  active_orders: 'Active Orders',
  your_liquidity_usd_value: 'Your Liquidity (USD value)',
  usage: 'Usage',
  holding: 'Holding',
  your_lp_tokens_and_shares: 'Your LP Tokens(Shares)',
  swapped: 'Swapped',
  dcl_pool: 'DCL Pool',
  classic: 'Classic',
  classic_farms: 'Classic Farms',
  locked_in: 'locked in',
  'deposit_near_tip_0.5': 'To deposit, keep at least 0.5 NEAR to cover gas fee',
  trade: 'Trade',
  earn_2: 'Earn',
  portfolio: 'Portfolio',
  more_2: 'More',
  liquidity_pools_2: 'Liquidity Pools',
  stable_pools: 'Stable Pools',
  pool_detail: 'Pool Detail',
  new_contract_deploy_tip:
    'A new contract has been deployed! Please remove your liquidity from the old contract',
  remove_will_automatically_claim:
    'Removing will automatically claim your unclaimed fees.',
  legacy_tip: 'Found unstaked LP tokens or rewards in',
  legacy_farms: 'Legacy Farms',
  all_farms: 'All Farms',
  your_farms_2: 'Your Farms',
  dcl_farms: 'DCL Farms',
  farm_type: 'Farm type',
  farm_2: 'Farm',
  to_claim: 'To Claim',
  liquidity_staked: 'Liquidity staked',
  dcl_pool_detail: 'DCL Pool Detail',
  reward_range: 'Reward Range',
  reward_range_tip: 'Farm reward within this range',
  ending_soon: 'Ending soon',
  farm_ended_tip: 'This farm has ended.',
  farm_will_ended_tip: 'This farm will end soon.',
  new_farm: 'New Farm',
  is_coming: 'is coming',
  est_apr: 'Est. APR',
  farming: 'Farming',
  unavailable: 'Unavailable',
  hide: 'Hide',
  show: 'Show',
  your: 'Your',
  max_apr: 'Max.APR',
  you_can_earn_tip: 'Farm available, farm APR up to',
  you_can_earn_current_tip:
    'Your current staked farm ended, and new farm is coming, est. APR is',
  go_new_farm: 'Go New Farm',
  go_farm: 'Go Farm',
  in_ended_farm: 'in ended farm',
  staked: 'Staked',
  in_farm_3: 'in farm',
  estimation: 'Estimation Value',
  this_staked_tip: 'This NFT has been staked',
  dcl_liquidity: 'DCL Liquidity',
  classic_liquidity: 'Classic Liquidity',
  will_appear_here_tip: 'Your liquidity positions will appear here.',
  dcl_will_appear_here_tip: 'Your DCL liquidity positions will appear here.',
  classic_will_appear_here_tip:
    'Your Classic liquidity positions will appear here.',
  price_range_overlap_ratio: ' Price Range Overlap Ratio',
  real_time_executed_orders: 'real-time executed orders',
  real_time_executed_orders_tip:
    'When placing a sell order above market price or a buy order below market price using limit order function, {appName} will attempt to execute a swap-with-stop-point action first, and if there is any remaining amount, a limit order will be created to fill the rest.<br> Real-time executed orders refer to orders placed using the limit order function but executed through swapping. In the "History" section, you can view real-time executed orders between the earliest displayed limit order in History up to the present time.',
  swapped_history_order: 'Swapped',
  ledger_guide_tip_1:
    'To successfully use your Ledger wallet for transactions, the ',
  ledger_guide_tip_2: 'feature has been automatically activated.',
  ledger_guide_tip_3: 'Please be aware',
  ledger_guide_tip_quote: '"',
  support_ledger_tip_new: '"Support Ledger"',
  ledger_guide_tip_4:
    'that due to Ledger wallet constraints, the current rate provided by the swap function',
  ledger_guide_tip_5: 'may not be the best price.',
  ledger_guide_tip_6: '.',
  your_trade_route: 'Your Trade Route',
  markets: 'Markets',
  exchanges: 'Exchanges',
  output_est: 'Output (est.)',
  new_swap_order_tip:
    'The price is from the {appName} AMM offer and for reference only. There is no guarente that your limit order will be immediately filled. ',
  instants_swap: 'Instant Swap',
  swappped: 'Swapped',
  claimed: 'Claimed',
  executing_capital: 'Executing',
  trade_route: 'Trade Route',
  settings: 'Settings',
  no_trade_routes: 'No Trade Routes',
  steps_in_the_route: 'Steps in the Route',
  swap_chart_no_data: 'Not enough data for the chart right now.',
  last_updated: 'Last Updated',
  steps_in_the_route_zh: '',
  Burrow: 'Burrow',
  Supplied: 'Supplied',
  APY: 'APY',
  top_bin_apr: 'Top Bin APR (24h)',
  size: 'Size',
};
export default Object.assign(uk_UA, uk_UA_in_risks_page);
